import { isDefinedError, ORPCError } from "@orpc/client";
import type { FireflyRuntime } from "@squide/firefly";
import { getI18nextPlugin } from "@squide/i18next";
import { toast } from "sonner";
import { i18NextInstanceKey } from "../i18next.ts";
import { handleForbiddenError } from "./handleForbiddenError.ts";
import { handleUnauthorizedError } from "./handleUnauthorizedError.ts";

export type UnmanagedMutationErrorHandler = (error: Error) => void;

function showToast(runtime: FireflyRuntime) {
    const plugin = getI18nextPlugin(runtime);
    const i18ninstance = plugin.getInstance(i18NextInstanceKey);
    const message = i18ninstance.t("toastMessage", { ns: "unmanagedMutationErrors" });

    toast.error(message, { id: "global-mutation-error" });
}

export function createUnmanagedMutationErrorHandler(runtime: FireflyRuntime) {
    const handler: UnmanagedMutationErrorHandler = error => {
        if (error instanceof ORPCError) {
            if (error.status === 400) {
                return;
            }

            if (error.status === 401) {
                handleUnauthorizedError(error, runtime);

                return;
            }

            if (error.status === 403 && !isDefinedError(error)) {
                handleForbiddenError(error, runtime);

                return;
            }
        }

        runtime.logger.withText("[web-app] An unmanaged mutation error occurred:").withError(error).error();

        showToast(runtime);
    };

    return handler;
}
